module.exports = __webpack_public_path__ + "img/cloud1.8786d752.png";